const styles = {
  container: {
    color: 'red'
  }
}

export default styles
